(function () {
  var heroes = document.querySelectorAll('[data-ca-campaign-hero]');

  heroes.forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-ca-campaign-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-ca-campaign-hero-dot]'));
    var interval = parseInt(hero.getAttribute('data-autoplay-interval'), 10) || 5200;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var index = 0;
    var timer;

    if (slides.length < 2) {
      return;
    }

    function syncVideoPlayback() {
      slides.forEach(function (slide, slideIndex) {
        var video = slide.querySelector('video');

        if (!video) {
          return;
        }

        if (slideIndex === index) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function showSlide(nextIndex) {
      index = nextIndex;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
      });

      syncVideoPlayback();
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
      }
    }

    function start() {
      if (!autoplay) {
        return;
      }

      stop();
      timer = window.setInterval(function () {
        showSlide((index + 1) % slides.length);
      }, interval);
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        showSlide(dotIndex);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    syncVideoPlayback();
    start();
  });
})();
